import { initialState } from './index';

const mutations = {
    setOpenedMobileMenu(state, value) {
        state.openedMobileMenu = value;
    },
    resetStateData(state) {
        let newState = Object.assign(state, initialState());
        state = newState;
    }
};

export default mutations;